import React, {FC} from 'react'
import {BadgeCounter, Stack, Typography, SelectionCard, Icon} from '@mdsol/onex-design'
import {useSelector} from 'react-redux'
import {useAppDispatch} from '../../../redux/config'
import {select_databaseIdToCopy} from '../../../redux/databases/selectors'
import {deleteCustomConfigOverride} from '../../../redux/databases/databases.duck'
import {select_auth_user} from 'redux/auth/selectors'

type props = {
  id: string,
  jobType: string,
  overrides: any[],
}

const CustomConfigOverride: FC<props> = ({id, jobType, overrides}) => {
  const jobTypeFormatted = jobType.replaceAll('_', ' ').trim()
  const databaseId = useSelector(select_databaseIdToCopy)
  const dispatch = useAppDispatch()
  const {isAdmin} = useSelector(select_auth_user)

  const handleDelete = (customConfigOverrideTag, jobType) => {
    dispatch(deleteCustomConfigOverride(databaseId, customConfigOverrideTag, jobType))
  }

  return (
    <>
      <SelectionCard
        className='selection-card-demo mt-1 selection-override'
        dataTestId={id}
        id={id}
        subtitle={jobTypeFormatted}
      >
        {
          overrides.map((item: any) => {
            const label: string = item?.name?.replace(/^Legion|([A-Z]+(?=[A-Z][a-z])|[A-Z][a-z]*)/g, (_, group1) => group1 ? ` ${group1}` : '').trim()
            const value: string = item?.value
            return (
              <Stack
                direction='horizontal'
                className='value-wrapper'
                role='custom-config-override-value-component'
                key={`${item.name}-id`}
              >
                <div className='config-title'>
                  <Typography variant='caption' size='large' semiBold>
                    {label}
                  </Typography>
                  <Typography variant='caption' size='tiny' color='caution'>
                    {item.name}
                  </Typography>
                </div>
                <div className='config-data-group'>
                  <BadgeCounter
                    variant='neutral'
                    className='neutral-custom-badge'
                    dataTestId={`value-${id}`}
                    id={id}>
                    {value}
                  </BadgeCounter>
                  {isAdmin &&
                    <Icon className='round-x-icon'
                      data-testid='round-x-icon'
                      onClick={() => handleDelete(item.name, jobType)}>
                        highlight_off
                    </Icon>
                  }
                </div>
              </Stack>)
          })
        }
      </SelectionCard>
    </>
  )
}

export default CustomConfigOverride
